/*
 * @Author: cmchiu
 * @Date: 2023-03-21 16:33:32
 * @LastEditTime: 2024-01-03 10:19:24
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \IACMP\IACMP_Client\src\utils\request.js
 *
 */
import axios from 'axios'
import { /* MessageBox, */ Message } from 'element-ui'
/* import store from '@/store'
import { getToken, setToken } from '@/utils/auth' */

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    headers: {
        post: { 'Content-Type': 'application/json;charset=UTF-8' },
    },
    timeout: 300000, // request timeout
    // 自訂可接收的Response狀態碼
    validateStatus: function(status) {
        return status < 400
    },
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        /* if (store.getters.token) {
            // let each request carry token
            // ['X-Token'] is a custom headers key
            // please modify it according to the actual situation
            config.headers['Authorization'] = 'Bearer ' + getToken()
        } */
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const rStatus = response.status
        const rData = response.data
        /* // 如果收到新的token就更新
        if (rData.renewToken && typeof rData.renewToken != 'undefined' && rData.renewToken != 0) {
            setToken(JSON.parse(rData.renewToken))
        } */

        if (rStatus >= 200 && rStatus < 300) {
            if (rData && typeof rData.Msg == 'string' && rData.Msg != '') {
                let duration = 0
                switch (rData.MsgType) {
                    case 'error':
                        duration = 1000 * 5
                        break
                    case 'warning':
                        duration = 1000 * 3
                        break
                    case 'success':
                        duration = 1000 * 2
                        break
                    case 'info':
                        duration = 1000 * 2
                        break
                }
                Message({
                    message: rData.Msg,
                    type: rData.MsgType,
                    duration,
                    dangerouslyUseHTMLString: true,
                    showClose: true,
                })
            }
            if (response.headers['content-length'] === '0') {
                return null
            } else {
                return rData
            }
        } else {
            Message({
                message: rData.Msg || 'Error',
                type: 'error',
                duration: 5 * 1000,
                dangerouslyUseHTMLString: true,
                showClose: true,
            })
            return Promise.reject(new Error(rData.Msg || 'Error'))
        }
    },
    error => {
        console.log('err' + error) // for debug
        Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000,
            dangerouslyUseHTMLString: true,
            showClose: true,
        })
        return Promise.reject(error)
    }
)

export default service
